<template>
  <div>
    <div
      class="alert text-left formatted-text"
      :class="{
        'alert-danger': message.error,
        'alert-success': !message.error,
      }"
      role="alert"
      v-show="message.display"
    >
      {{ this.message.content }}
    </div>

    <div class="row">
      <form class="col-md-6">
        <div class="form-group row">
          <label class="col-md-3 text-right">Note:</label>
          <label type="text" class="col-md-8 text-left font-weight-bold">{{
            review.note
          }}</label>
        </div>
        <div class="form-group row">
          <label class="col-md-3 text-right">Commentaire:</label>
          <label type="text" class="col-md-8 text-left font-weight-bold">{{
            review.comment
          }}</label>
        </div>
        <div class="form-group row">
          <label class="col-md-3 text-right">Ajouté le:</label>
          <label
            v-if="review.created_at"
            type="text"
            class="col-md-8 text-left font-weight-bold"
          >
            {{
              review.created_at
                | dateParse("YYYY-MM-DD HH:mm:ss")
                | dateFormat("DD/MM/YYYY HH:mm:ss")
            }}
          </label>
        </div>
      </form>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">PERSONNEL</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Nom:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.lastname
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Prénom(s):</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.firstname }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Sexe:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.gender === "male" ? "Masculin" : "Féminin"
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date naissance:</label>
              <label
                v-if="review.demand.birth_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  review.demand.birth_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Lieu naissance:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.birth_place
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays naissance:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.birth_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Nationalité:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.citizenship_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Autre nationalité:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.other_citizenship_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays résidence:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.residence_country_name
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Profession:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.occupation
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Téléphone:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.contact01
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Autre téléphone:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.contact02
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Adresse:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.adress
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Email:</label>
              <label type="text" class="col-md-8 text-left font-weight-bold">{{
                review.demand.email
              }}</label>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">VOYAGE</legend>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Date du précédent séjour au Bénin:</label
              >
              <label
                v-if="review.demand.previous_stayin_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
              >
                {{
                  review.demand.previous_stayin_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Date Entrée au Bénin:</label>
              <label
                v-if="review.demand.arrival_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
                >{{
                  review.demand.arrival_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}</label
              >
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Date de départ du Bénin:</label
              >
              <label
                v-if="review.demand.departure_date"
                type="text"
                class="col-md-7 text-left font-weight-bold"
                >{{
                  review.demand.departure_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}</label
              >
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">
                Adresse de résidence au Bénin:
              </label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.local_adress }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Durée du séjour:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.stayin_duration }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right"
                >Destination suivante après Bénin:
              </label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.country_after_departure_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Moyens de subsistance:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.stayin_garanty }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Garantie de retour:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.return_garanty }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-5 text-right">Motif du voyage:</label>
              <label type="text" class="col-md-7 text-left font-weight-bold">
                {{ review.demand.travel_purpose }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">E-VISA</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Référence: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.reference }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Type de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.visatype_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Durée de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.visatype_duration }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Demande en ambassade: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.priority ? "Oui" : "Non" }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Coût de l'eVisa: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.amount }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Recherché: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                <span
                  :class="{
                    'badge badge-success': !review.demand.matched,
                    'badge badge-danger': review.demand.matched,
                  }"
                  >{{
                    review.demand.matched ? review.demand.matched : "Non"
                  }}</span
                >
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Status: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                <span
                  :class="{
                    'badge badge-success': review.demand.state === 'GENERATED',
                    'badge badge-warning': [
                      'VALIDATION',
                      'PROCESSING',
                    ].includes(review.demand.state),
                    'badge badge-danger': review.demand.state === 'REJECTED',
                  }"
                  >{{ DEMAND_STATUS_TRANSLATION[review.demand.state] }}
                </span>
              </label>
            </div>
            <div v-if="review.demand.visa_issuing_date" class="form-group row">
              <label class="col-md-3 text-right">Généré le: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{
                  review.demand.visa_issuing_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div v-if="review.demand.visa_expiry_date" class="form-group row">
              <label class="col-md-3 text-right">Expire le: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{
                  review.demand.visa_expiry_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-md-6">
        <form>
          <fieldset>
            <legend class="view-legend">PASSEPORT</legend>
            <div class="form-group row">
              <label class="col-md-3 text-right">Pays de délivrance: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.document_issuer_country_name }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Numéro: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.document_number }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Type de document: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.document_type | capitalize }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date de délivrance: </label>
              <label
                v-if="review.demand.document_delivery_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  review.demand.document_delivery_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>
            <div class="form-group row">
              <label class="col-md-3 text-right">Date d'expiration: </label>
              <label
                v-if="review.demand.document_expiry_date"
                type="text"
                class="col-md-8 text-left font-weight-bold"
              >
                {{
                  review.demand.document_expiry_date
                    | dateParse("YYYY-MM-DD")
                    | dateFormat("DD/MM/YYYY")
                }}
              </label>
            </div>

            <hr />

            <!-- Champ de commentaire pour affichage simple -->
            <div class="form-group row">
              <label class="col-md-3 text-right">Commentaire: </label>
              <label type="text" class="col-md-8 text-left font-weight-bold">
                {{ review.demand.comment }}
              </label>
            </div>
          </fieldset>
        </form>
      </div>
    </div>

    <div class="form-group row">
      <!-- <label class="col-md-8"></label> -->
      <div class="col-md-12 text-center">
        <router-link
          class="btn btn-dark action-btn-cancel"
          :to="{ name: 'reviews' }"
        >
          Retourner
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DEMAND_STATUS_TRANSLATION } from "@/helpers/messages";

export default {
  name: "ReviewViewForm",
  data() {
    return {
      country: {},
      message: {
        error: false,
        display: false,
        content: "",
      },
      DEMAND_STATUS_TRANSLATION,
    };
  },
  computed: {
    ...mapGetters({ review: "review" }),
  },
  mounted() {},

  methods: {},
};
</script> 